import CryptoJS from 'crypto-js';

export const encryptData = (data) => {
  try {
    if (!process.env.REACT_APP_ENCRYPT_KEY) {
      throw new Error('Secret key not provided!');
    }

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      process.env.REACT_APP_ENCRYPT_KEY
    ).toString();
    return encrypted;
  } catch (error) {
    return null;
  }
};

export const decryptData = (name) => {
  try {
    if (!process.env.REACT_APP_ENCRYPT_KEY) {
      throw new Error('Secret key not provided!');
    }
    const decrypted = CryptoJS.AES.decrypt(
      name,
      process.env.REACT_APP_ENCRYPT_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    return null;
  }
};
